export default "__VITE_ASSET__K5Z_htC___"